import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { buildUrl, toastServerError } from "helpers";
import { ApiError, ApiServiceError, instance } from "libs/api";

import { AiAssistantTool } from "../../aiAgents.types";
import {
  AI_ASSISTANTS_QUERY_KEY,
  AiAssistantSubRoute,
  ApiRoutesAiAssistants
} from "../../constants/enums";

const toolsKey = (assistantId: string) => [
  AI_ASSISTANTS_QUERY_KEY,
  "tools",
  assistantId
];

const toolsBase = (assistantId: string) =>
  buildUrl(ApiRoutesAiAssistants.Assistants, assistantId, AiAssistantSubRoute.Tools);

export const useGetTools = (assistantId: string | undefined) => {
  const query = useQuery<{ data: AiAssistantTool[] }, ApiServiceError<ApiError>>(
    {
      queryKey: toolsKey(assistantId ?? ""),
      queryFn: async () => await instance.get(toolsBase(assistantId!)),
      enabled: Boolean(assistantId),
      onError: toastServerError
    }
  );

  return { tools: query.data?.data ?? [], ...query };
};

export const useToggleTool = (assistantId: string) => {
  const queryClient = useQueryClient();
  return useMutation<
    AiAssistantTool,
    ApiServiceError<ApiError>,
    { toolKey: string; isEnabled: boolean }
  >({
    mutationFn: async ({ toolKey, isEnabled }) =>
      await instance.patch(buildUrl(toolsBase(assistantId), toolKey), {
        isEnabled
      }),
    onError: toastServerError,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: toolsKey(assistantId) })
  });
};
